// 域名
// 手机访问测试的域名，配合nginx来用
// var DOMAIN = 'hnyd'  //

// 平时开发访问测试的域名
var DOMAIN = 'https://emm.cmccbigdata.com:8443/'  // 正式域名
if (process.env.NODE_ENV === 'development') {  // 开发环境下，引入本地地址，上线就不需要
  DOMAIN = 'http://localhost:8080/'
}
if (process.env.NODE_ENV === 'test') {  // 测试域名
  DOMAIN = 'https://emm.cmccbigdata.com:8443/'
}

export default DOMAIN



// WEBPACK FOOTER //
// ./src/libs/domain.js